import { ResponseError } from '../../../errors';
import {
  IGetInfrastructureGeoObjectsResponse200,
  TGetInfrastructureGeoObjectsResponse,
} from '../../../repositories/infrastructure-caching/v1/get-infrastructure-geo-objects';

export function assertFetchGetInfrastructureGeoObjectsResponse(
  response: TGetInfrastructureGeoObjectsResponse,
): asserts response is IGetInfrastructureGeoObjectsResponse200 {
  if (response.statusCode !== 200) {
    throw new ResponseError({
      message: response.response.message,
      domain: 'assertFetchGetInfrastructureGeoObjectsResponse',
    });
  }
}
